import ApiService from '../../../../../services/ApiService'

export default {
  props: {
    title: String,
    metricRange: Object,
    calibrationId: Number,
    calibration: Object,
    newMeasurementModel: Object,
    serviceOrderId: Number,
    ranges: Array,
    patterns: Array,
  },

  async created() {
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.getCalibrationPattern()
    this.currentCalibration.id = this.calibrationId

    if (this.ranges) {
      if (
        this.ranges.filter((x) => x.calibrationPatternTemplateParameter != null)
          .length > 0
      ) {
        this.ranges
          .map((x) => x.calibrationPatternTemplateParameter)
          .forEach((item) => {
            var duplicated =
              this.distinctRanges.findIndex((redItem) => {
                return item.id == redItem.id
              }) > -1

            if (!duplicated) {
              this.distinctRanges.push(item)
              this.originalRanges.push(item)
            }
          })
      } else {
        this.distinctRanges = this.ranges
        this.originalRanges = this.ranges
      }
    }

    if (this.calibration) {
      this.currentCalibration = this.calibration
    }

    if (this.metricRange) {
      this.currentMetricRange = this.metricRange
      this.calibrationPatternMetricsRange =
        this.metricRange.calibrationPatternMetricsRange
      this.currentCalibration.id = this.metricRange.calibrationId
      this.valueOne = this.metricRange.valueOne
      this.valueTwo = this.metricRange.valueTwo
      this.valueThree = this.metricRange.valueThree
      this.valueFour = this.metricRange.valueFour
      this.valueFive = this.metricRange.valueFive
      this.k = this.metricRange.k
      this.uncertainty = this.metricRange.uncertainty
      this.tendency = this.metricRange.tendency
      this.range = this.metricRange.range
      this.calibrationPatternId =
        this.metricRange.calibrationPatternMetricsRange.calibrationPatternMetrics.calibrationPatternId
      await this.listCalibrationMetrics()
      this.calibrationPatternMetric =
        this.metricRange.calibrationPatternMetricsRange.calibrationPatternMetrics
      this.getResolution()
      this.resolutionEquipment = this.getResolutionEquipment(
        this.metricRange.calibrationPatternTemplateParameterId
      )
      this.currentCalibrationPatternTemplateParameter =
        this.metricRange.calibrationPatternTemplateParameter
      this.isEditing = true
    }

    if (this.newMeasurementModel) {
      this.measurementModel = this.newMeasurementModel
      this.calibrationPatternId = this.measurementModel.CalibrationPatternId
      await this.listCalibrationMetrics()
      this.calibrationPatternMetric =
        this.measurementModel.CalibrationPatternTemplateParametersMetricsRanges.calibrationPatternMetricsRange.calibrationPatternMetrics
      this.getResolution()
      this.resolutionEquipment = this.measurementModel.ResolutionEquipment
      this.currentCalibrationPatternTemplateParameter =
        this.measurementModel.Parameter
      this.calibrationPatternMetricsRange =
        this.measurementModel.CalibrationPatternTemplateParametersMetricsRanges.calibrationPatternMetricsRange
      this.inputDisabled = true
      this.newMeasurement = true

      this.calibrationPatternId =
        this.measurementModel.Parameter.calibrationPatternId
    }
  },

  data: () => ({
    step: 0,
    institution: {},
    errorMessage: '',
    loading: false,
    deleteLoading: false,
    calibrationPatternLoading: false,
    calibrationMetricsLoading: false,
    firstValid: true,
    alterDialog: false,
    deleteDialog: false,
    changedData: false,
    isEditing: false,
    error: false,
    inputDisabled: false,
    newMeasurement: false,
    changeEquipmentResolution: false,
    valueOne: null,
    valueTwo: null,
    valueThree: null,
    valueFour: null,
    valueFive: null,
    k: '',
    uncertainty: '',
    tendency: '',
    resolutionEquipment: '',
    resolutionPattern: '',
    range: '',
    originalRanges: [],
    distinctRanges: [],
    institutionId: null,
    currentCalibrationPatternTemplateParameter: {
      id: 0,
      fixedValue: false,
      name: '',
      tolerance: '',
    },
    calibrationPatternMetricsRange: {
      id: 0,
      range: '',
      k: '',
      uncertainty: '',
      tendency: '',
    },
    calibrationPatternId: null,
    calibrationPatterns: [],
    calibrationPatternMetric: null,
    calibrationPatternMetrics: [],
    currentCalibration: {},
    currentMetricRange: {},
    measurementModel: {},
    userLogged: {},
    metricRanges: [],
    nameRules: [
      (v) => !!v || 'Parâmetro requerido',
      (v) =>
        (v && v.length <= 128) || 'Parâmetro deve ter no máximo 128 caracteres',
    ],
    calibrationPatternRulles: [(v) => !!v || 'Padrão requerido'],
    calibrationMetricRulles: [(v) => !!v || 'Métrica requerida'],
    toleranceRules: [
      (v) => parseInt(v) >= 0 || parseInt(v) <= 0 || 'Tolerância requerida',
    ],
    rangeRules: [
      (v) => parseInt(v) >= 0 || parseInt(v) <= 0 || 'Faixa é requerida',
    ],
    kRules: [(v) => parseInt(v) >= 0 || parseInt(v) <= 0 || 'K é requerido'],
    uncertaintyRules: [
      (v) => parseInt(v) >= 0 || parseInt(v) <= 0 || 'Incerteza é requerida',
    ],
    tendencyRules: [
      (v) => parseInt(v) >= 0 || parseInt(v) <= 0 || 'Tendência é requerida',
    ],
    resolutionEquipmentRules: [
      (v) => !!v || 'Resolução equipmento é requerida',
    ],
    apiService: new ApiService(),
  }),

  computed: {
    currentTitle() {
      switch (this.step) {
        case 0:
          return 'Dados Medição'
        default:
          return this.isEditing ? 'Atualização efetuada' : 'Cadastro efetuado'
      }
    },

    buttonText() {
      switch (this.step) {
        case 0:
          return this.isEditing ? 'Atualizar' : 'Adicionar'
        default:
          return 'Terminar'
      }
    },
  },

  methods: {
    calculateParameters() {
      this.currentCalibrationPatternTemplateParameter = {}
      if (this.calibrationPatternMetric) {
        const ranges = this.originalRanges.filter(
          (x) =>
            x.calibrationPatternId == this.calibrationPatternId &&
            x.calibrationPatternMetricsId == this.calibrationPatternMetric.id
        )

        if (ranges.length > 0) {
          this.distinctRanges = ranges
        }
      }
    },

    close() {
      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$emit('close')
      }
    },

    closeDialog() {
      this.changedData = false
      this.close()
    },

    changePattern() {
      this.listCalibrationMetrics()
      this.calculateInterpolation(this.range)
      this.calculateParameters()
    },

    changeMetric() {
      this.getResolution()
      this.calculateInterpolation(this.range)
      this.calculateParameters()
    },

    async getCalibrationPattern() {
      this.calibrationPatternLoading = true
      await this.apiService
        .get(`calibrationPattern/list`)
        .then(async (response) => {
          this.calibrationPatterns = response.content

          if (this.ranges.length > 0) {
            const patternIds = this.ranges.map(
              (x) => x.calibrationPatternTemplateParameter.calibrationPatternId
            )

            this.calibrationPatterns = this.calibrationPatterns.filter((x) =>
              patternIds.includes(x.id)
            )
          } else {
            this.calibrationPatterns = this.calibrationPatterns.filter(
              (x) => x.institutionId == this.institutionId
            )

            await this.apiService
              .get(`calibrationPattern/approved/${this.institutionId}`)
              .then((response) => {
                this.calibrationPatterns.push(
                  ...response.content.map((x) => x.calibrationPatternRequester)
                )
              })
          }

          this.calibrationPatternLoading = false
        })
        .catch(() => {
          this.calibrationPatternLoading = false
        })
    },

    async listCalibrationMetrics() {
      await this.apiService
        .get(`calibrationPatternMetrics/list/${this.calibrationPatternId}`)
        .then((response) => {
          this.calibrationPatternMetrics = response.content
          const metricIds = this.ranges.map(
            (x) => x.calibrationPatternMetricsRange.calibrationPatternMetrics.id
          )

          const metrics = this.calibrationPatternMetrics.filter((x) =>
            metricIds.includes(x.id)
          )

          this.calibrationPatternMetrics =
            metrics.length > 0 ? metrics : response.content
        })
    },

    getResolution() {
      const metric = this.calibrationPatternMetrics.find(
        (x) => x.id === this.calibrationPatternMetric.id
      )

      this.resolutionPattern = metric
        ? metric.resolution
        : this.calibrationPatternMetrics[0].resolution
    },

    getResolutionEquipment(value) {
      const parameter = this.currentCalibration.templateParameters.find(
        (x) => x.calibrationPatternTemplateParameterId === value
      )
      if (parameter) {
        return parameter.resolutionEquipment
      }
    },

    async next() {
      if (this.step === 0) {
        if (this.$refs.firstForm.validate()) {
          this.submit()
        }
      } else {
        this.closeDialog()
      }
    },

    async submit() {
      this.loading = true

      const calibrationPatternTemplateParameter =
        this.currentCalibrationPatternTemplateParameter

      calibrationPatternTemplateParameter.calibrationPatternMetricsId =
        this.calibrationPatternMetric.id

      const calibrationPatternMetricRange = {
        Id: this.calibrationPatternMetricsRange.id,
        ServiceOrderId: this.serviceOrderId,
        Range: this.range,
        K: this.k,
        Uncertainty: this.uncertainty,
        Tendency: this.tendency,
        CalibrationPatternMetricsId: this.calibrationPatternMetric.id,
        CreatedByOrder: false,
      }

      const calibrationNewMeasurementModel = {
        CalibrationId: this.currentCalibration.id,
        CalibrationPatternId: this.calibrationPatternId,
        CalibrationPatternMetricId: this.calibrationPatternMetric.id,
        CalibrationPatternMetricsRange: calibrationPatternMetricRange,
        CalibrationPatternTemplateParameter:
          calibrationPatternTemplateParameter,
        ResolutionEquipment: this.resolutionEquipment,
        ValueOne: this.valueOne,
        ValueTwo: this.valueTwo,
        ValueThree: this.valueThree,
        ValueFour: this.valueFour,
        ValueFive: this.valueFive,
      }

      if (this.newMeasurement) {
        calibrationPatternMetricRange.Id = 0
        calibrationPatternMetricRange.CreatedByOrder = true
        await this.apiService
          .post(
            'calibrationPatternMetricsRange/add',
            calibrationPatternMetricRange
          )
          .then((response) => {
            calibrationPatternMetricRange.Id = response.content.id
            const newRange = {
              CalibrationPatternMetricRange: calibrationPatternMetricRange,
              CalibrationPatternMetric: this.calibrationPatternMetric,
              CalibrationPatternTemplateParameter:
                calibrationPatternTemplateParameter,
              ValueOne: this.valueOne,
              ValueTwo: this.valueTwo,
              ValueThree: this.valueThree,
              ValueFour: this.valueFour,
              ValueFive: this.valueFive,
              ResolutionEquipment: this.resolutionEquipment,
            }
            this.$emit('addNewRange', { range: newRange })
            this.newMeasurement = false
            this.closeDialog()
          })
      } else {
        let url = 'calibration/newMeasurement'

        if (this.isEditing) {
          url = 'calibration/editMeasurement'
        } else {
          calibrationNewMeasurementModel.CalibrationPatternTemplateParameter.calibrationPattern =
            undefined
        }

        await this.apiService
          .post(url, calibrationNewMeasurementModel)
          .then((response) => {
            this.step++

            this.loading = false
          })
          .catch((err) => {
            this.errorMessage = err.body.message
            this.error = true

            this.loading = false
            this.changedData = false

            setTimeout(() => {
              this.error = false
            }, 4000)
          })
      }
    },

    async removeMeasurement() {
      this.deleteLoading = true

      await this.apiService
        .delete('calibration/deleteMeasurement', this.metricRange)
        .then((response) => {
          this.closeDialog()
          sessionStorage.clear()
          sessionStorage.setItem(
            'calibration',
            JSON.stringify(response.content)
          )
        })
    },

    async calculateInterpolation(newRange) {
      if (newRange) {
        const model = {
          CalibrationPatternId: this.calibrationPatternId,
          CalibrationPatternMetricsId: this.calibrationPatternMetric.id,
          NewRange: newRange,
        }

        await this.apiService
          .post('calibration/calculateInterpolation', model)
          .then((response) => {
            this.k = response.content.k
            this.uncertainty = response.content.uncertainty
            this.tendency = response.content.tendency
            this.$forceUpdate()
          })
          .catch((err) => {
            this.errorMessage = err.body.message
            this.error = true

            setTimeout(() => {
              this.error = false
            }, 4000)
          })
      }
    },
  },

  watch: {
    calibrationPatternId: {
      deep: true,
      handler() {
        if (this.isEditing) {
          this.changedData = true
        }
      },
    },
  },
}
